import { Injectable } from '@angular/core';
import { LoggingService } from '../../shared/services/core/logging.service';
import { AuctionBidService } from './auction-bid.service';

@Injectable({ providedIn: 'root' })
export class AuctionBidsResolver {
  constructor(private auctionBidService: AuctionBidService, private logService: LoggingService) {}

  resolve() {
    this.logService.info(`Resolving all historical bids`);
    return this.auctionBidService.fetchBids();
  }
}
